import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css/theme.css";

export const titleStyles = style({
  marginBottom: theme.spacings.xs,
});
